/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { CountryItem } from '../../models/country-item';

export interface CountryControllerAddCountryPicture$Params {
  iso: string;
      body: {
'picture'?: Blob;
}
}

export function countryControllerAddCountryPicture(http: HttpClient, rootUrl: string, params: CountryControllerAddCountryPicture$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: CountryItem;
}>> {
  const rb = new RequestBuilder(rootUrl, countryControllerAddCountryPicture.PATH, 'put');
  if (params) {
    rb.path('iso', params.iso, {});
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: CountryItem;
      }>;
    })
  );
}

countryControllerAddCountryPicture.PATH = '/country/{iso}/picture';
